import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card } from '@servicetitan/anvil2';
import { TitleValue } from './common/title-value';
import { getFString } from '../../utils/get-f-string';
import classNames from 'classnames';
import { PressureSetPointsResponseDto } from '../../models/pressure-set-points.response.dto';

export const PressureSetPointsAnswer: FC<{
    data: PressureSetPointsResponseDto;
    className?: string;
}> = observer(({ data, className }) => {
    return (
        <Card className={classNames('w-100-i', className)}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: 12 }}>
                <TitleValue title="liquid line" value={getFString(data.liquid)} />
                <TitleValue title="discharge line" value={getFString(data.discharge)} />
                <TitleValue title="suction line" value={getFString(data.suction)} />
            </div>
        </Card>
    );
});
